import { MARQUEE_ITEMS } from "@/data/site";

export default function Marquee() {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            data-testid="marquee-strip"
            className="overflow-hidden border-y border-[#D4AF37]/20 bg-[#0B0B0C] py-5"
            aria-hidden="true"
        >
            <div className="marquee-track">
                {items.map((item, i) => (
                    <span
                        key={i}
                        className="font-mono-lux flex items-center whitespace-nowrap text-xs tracking-[0.35em] text-[#D4AF37]/80"
                    >
                        <span className="px-8">{item}</span>
                        <span className="text-[#D4AF37]/40">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
